import HeaderBox from "@/components/HeaderBox";
import { Link } from "react-router-dom";

import AnimatedPage from "@/components/AnimatedPage";
import HelmetMetaData from "@/components/HelmetMetaData";

import Monnify from "@/components/dashboard/payment-system/Monnify";
import VirtualAccount from "@/components/dashboard/payment-system/VirtualAccount";
import ManualBankTransfer from "@/components/dashboard/payment-system/ManualBankTransfer";
import { useState } from "react";
import { useSelector } from "react-redux";
import Squad from "@/components/dashboard/payment-system/Squad";
import Paystack from "@/components/dashboard/payment-system/Paystack";

const FundWallet = () => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user.user);

  return (
    <>
      <HelmetMetaData
        title="Fund Wallet"
        description="Add money to your wallet via bank transfer to virtual account or instant payment methods. Fund your account securely to access our services."
      />

      <AnimatedPage>
        <div className="relative p-3 sm:p-5 md:h-[90dvh]">
          <div className="mb-5 flex flex-col-reverse items-start justify-between md:flex-row">
            <div className="flex flex-col gap-1">
              <h1 className="lg:text-30 text-[24px] leading-[30px] font-bold text-gray-900 lg:text-[30px] lg:leading-[34px] dark:text-white">
                Fund Wallet
              </h1>
              <p className="lg:text-16 dark:text-darkGray text-[14px] leading-[20px] font-normal text-gray-600 lg:text-[16px] lg:leading-[24px]">
                Add money either via bank transfer to virtual account or via
                instant payment. <br className="hidden lg:block" />
                <strong>
                  Note: All Deposit methods except{" "}
                  <span className="text-primary">Manual Funding</span> has a
                  charge of ₦{user.meta_data.transaction_charges} for deposits
                  above ₦2,500.
                </strong>
              </p>{" "}
            </div>

            <div>
              <h2 className="text-sm font-medium">
                <Link to="/dashboard" className="hover:underline">
                  Dashboard
                </Link>

                <span className="px-2 text-xl font-thin">/</span>

                <span className="text-gray-400">Fund Wallet</span>
              </h2>
            </div>
          </div>

          <div className="mt-5 grid grid-cols-1 gap-6 pb-5 md:gap-4 lg:grid-cols-3 lg:gap-7">
            {/* Manual Bank Transfer */}
            {user.meta_data.virtual_payment_method_active && <VirtualAccount />}
            {user.meta_data.squad_payment_method_active && <Squad />}
            {user.meta_data.monnify_payment_method_active && (
              <Monnify loading={loading} />
            )}
            {user.meta_data.paystack_payment_method_active && <Paystack />}
            {user.meta_data.manual_payment_method_active && (
              <ManualBankTransfer loading={loading} />
            )}
          </div>
        </div>
      </AnimatedPage>
    </>
  );
};

export default FundWallet;
